module.exports = __webpack_public_path__ + "static/media/4c44b066-2de3-4513-b4ea-838d5f2dfa4d_1.4b1747ebd1185661f22358a701145a32.a9cf8f66.jpeg";